/**
 * Shopping 도메인 쿼리 키 팩토리
 *
 * 컨벤션: 도메인명 복수형, 하위 키는 동사/명사
 * 'use client' 없음 — 서버/클라이언트 모두에서 import 가능
 */

import { createQueryKeys } from "@/shared/api/query-keys";

export const productKeys = {
  ...createQueryKeys("products"),
  search: (keyword: string) => ["products", "search", keyword] as const,
};

export const productDetailKeys = createQueryKeys("products-detail");

export const favoriteKeys = {
  all: ["favorites"] as const,
  check: (productId: string) => ["favorites", "check", productId] as const,
  list: () => ["favorites", "list"] as const,
  details: (productIds: number[]) => ["favorites", "details", productIds] as const,
};
